export const noPolicyContextsSelected = ({ policyContextMap, selectedCategory, selectedContexts }) => {
  if (!(policyContextMap[selectedCategory]?.length > 0)) {
    return false;
  }

  // returns false if any selected policy contexts are truthy
  return policyContextMap[selectedCategory].every((policyContext) => {
    return !selectedContexts[policyContext];
  });
};
